import { render, staticRenderFns } from "./spuSearchInput.vue?vue&type=template&id=fb82928e&"
import script from "./spuSearchInput.vue?vue&type=script&lang=js&"
export * from "./spuSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports